import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ExternalLink } from '@isophi/core-legacy';
import { BehaviorSubject } from 'rxjs';

import { PreparedLink } from '../../pipes/prepare-links.pipe';

@Component({
    selector: 'app-prepared-link',
    templateUrl: './prepared-link.component.html',
    styles: [
        `
      :host {
        display: flex;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PreparedLinkComponent {
  @Input() set preparedLink(value: PreparedLink) {
    this.routerLink$.next(null);
    this.externalLink$.next(null);

    if (value instanceof Array) {
      this.routerLink$.next(value);
      return;
    }
    this.externalLink$.next(value);
    this.routerLinkActive = false;
  }

  @Input() queryParams: Record<string, unknown>;

  @Input() anchorClass: string;

  @HostBinding('class.active') routerLinkActive = false;

  protected readonly routerLink$ = new BehaviorSubject<string[] | null>(null);

  protected readonly externalLink$ = new BehaviorSubject<ExternalLink | null>(null);
}
